import React from 'react'

import {
  AddressTextField,
  BirthDateTextField,
  CityTextField,
  DocumentTextField,
  NameTextField,
  NumberTextField,
  StateTextField,
  EmailTextField,
  PostalCodeTextField,
  StreetTextField,
} from 'components/ComponentsTextField'

const DynamicInputField = ({
  input,
  control,
  setValue,
  renderInput,
  errors,
}) => {
  switch (input.name) {
    case 'birthDate':
      return (
        <BirthDateTextField
          input={input}
          setValue={setValue}
          control={control}
        />
      )
    case 'name':
      return (
        <NameTextField
          input={input}
          setValue={setValue}
          control={control}
          errors={errors}
        />
      )
    case 'email':
      return (
        <EmailTextField
          input={input}
          setValue={setValue}
          control={control}
          errors={errors}
        />
      )
    case 'document':
      return (
        <DocumentTextField
          input={input}
          setValue={setValue}
          control={control}
        />
      )
    case 'address.state':
      return (
        <StateTextField
          input={input}
          setValue={setValue}
          control={control}
          errors={errors}
        />
      )
    case 'address.city':
      return (
        <CityTextField
          input={input}
          setValue={setValue}
          control={control}
          errors={errors}
        />
      )
    case 'address.number':
      return (
        <NumberTextField
          input={input}
          setValue={setValue}
          control={control}
          errors={errors}
        />
      )
    case 'address.neighborhood':
      return (
        <AddressTextField
          input={input}
          setValue={setValue}
          control={control}
          errors={errors}
        />
      )
    case 'address.street':
      return (
        <StreetTextField
          input={input}
          setValue={setValue}
          control={control}
          errors={errors}
        />
      )
    case 'address.postalCode':
      return (
        <PostalCodeTextField
          input={input}
          setValue={setValue}
          control={control}
          errors={errors}
        />
      )
    default:
      return (
        <NameTextField input={input} setValue={setValue} control={control} />
      )
  }
}

export default DynamicInputField
